'use strict';

define('vb/extensions/dynamic/private/models/context/layoutResourceContext',['vb/private/stateManagement/context/containerContext'], (ContainerContext) => {
  /**
   * Context object for a LayoutResource.
   */
  class LayoutResourceContext extends ContainerContext {
    static get BaseContextType() {
      return LayoutResourceContext;
    }

    /**
     * @param layoutResource
     * @returns {Object}
     */
    static getAvailableContexts(layoutResource) {
      const availableContexts = super.getAvailableContexts(layoutResource);
      const filteredContexts = {};

      // Expose just modules and translations bundles for all layout resources.
      // We don't want a layout to have access to it's parent container's variables.
      // Otherwise, you can't embed it in any arbitrary container.
      ['$functions', '$modules', '$translations'].forEach((key) => {
        const propDesc = Object.getOwnPropertyDescriptor(availableContexts, key);

        Object.defineProperty(filteredContexts, key, propDesc);
      });

      return filteredContexts;
    }
  }

  return LayoutResourceContext;
});

